/* eslint-disable prettier/prettier */
import styled from 'styled-components';
import { ColorPalette } from 'theme/colors';

import { ReactComponent as Arrow } from 'assets/images/arrow-forw.svg';
import { ReactComponent as BaseCarIcon } from 'assets/images/autos/icon-car.svg';
import { ReactComponent as Bed } from 'assets/images/bed.svg';
import { ReactComponent as Group } from 'assets/images/group.svg';
import { ReactComponent as Guest } from 'assets/images/invite.svg';
import { ReactComponent as Money } from 'assets/images/money.svg';
import { ReactComponent as Plane } from 'assets/images/plane-flying.svg';
import AirlineImg from 'components/AirlineLogo';
import { FaRegCheckCircle } from 'react-icons/fa';

type FlightDetailsProps = {
  $right?: boolean;
};

type PlaneIconProps = {
  $return?: boolean;
};

export const Card = styled.div`
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  height: fit-content;
  background: ${ColorPalette.HEX.White};
  border-radius: 16px;
  box-shadow: 0 2px 12px 0 rgba(${ColorPalette.RGB.DeepTaupe2}, 0.16);
  margin: 0 16px 24px 16px;
  width: 345px;

  @media ${({ theme }) => theme.device.desktop} {
    margin: 0 32px 32px 0;
    align-self: flex-start;
  }
`;

export const Header = styled.section`
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  padding: 24px;
`;

export const Info = styled.aside``;

export const Title = styled.h4`
  font-size: 12px;
  color: ${ColorPalette.HEX.DimGray};
`;

export const Section = styled.section`
  display: flex;
  width: 100%;
  align-items: flex-start;
  padding: 0 24px 24px 24px;
  color: ${ColorPalette.HEX.Gunmetal};
`;

export const Traveler = styled.span`
  color: ${ColorPalette.HEX.CharlestonGreen};
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 4px;
`;

export const Price = styled.span`
  font-size: 12px;
  font-weight: 600;
  line-height: 1.33;
  letter-spacing: -0.2px;
  color: ${({ theme }) => theme.requestCard.textColor};
  margin-bottom: 4px;
  margin-left: auto;

  & > small {
    font-size: 10px;
  }
`;

export const Destination = styled.span`
  font-size: 16px;
  color: ${ColorPalette.HEX.Gunmetal};
  font-weight: 600;
`;

export const DestinationDetail = styled.span`
  font-size: 12px;
  letter-spacing: -0.2px;
  color: ${ColorPalette.HEX.Manatee};
`;

export const FlightTimeTurnDays = styled.span`
  font-size: 10px;
  letter-spacing: -0.2px;
  color: ${ColorPalette.HEX.Manatee};
`;

export const FlightDetails = styled.div<FlightDetailsProps>`
  display: flex;
  margin-left: ${({ $right }) => ($right ? 'auto' : 0)};
`;

export const OperatorName = styled.span`
  font-size: 10px;
  color: ${ColorPalette.HEX.Manatee};
  margin-top: 2px;
`;

export const AutoDetails = styled.div<FlightDetailsProps>`
  display: flex;
  flex: 1;
  margin-left: ${({ $right }) => ($right ? 'auto' : 0)};
`;

export const UserLabel = styled.span`
  display: flex;
  align-items: center;

  font-size: 12px;
  line-height: 1.33;
  letter-spacing: -0.2px;
  color: ${ColorPalette.HEX.Manatee};
`;

export const ButtonContainer = styled.section`
  width: 100%;
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 16px;
  padding: 16px;
  justify-content: space-between;
  border-top: solid 1px ${({ theme }) => theme.requestCard.border};
`;

export const BedIcon = styled(Bed)`
  margin-right: 12px;
  width: 18px;
`;

export const MoneyIcon = styled(Money)`
  margin-right: 12px;
  width: 18px;
`;

export const PlaneIcon = styled(Plane)<PlaneIconProps>`
  margin-right: 12px;
  width: 18px;
  transform: scaleX(${({ $return }) => ($return ? -1 : 1)});
  align-self: flex-start;
`;

export const GroupIcon = styled(Group)`
  margin-right: 4px;
`;

export const GuestIcon = styled(Guest)`
  margin-right: 4px;
`;

export const CarIcon = styled(BaseCarIcon)`
  margin-right: 12px;
  width: 18px;
  height: 18px;
`;

export const ArrowIcon = styled(Arrow)`
  width: 16px;
  height: 16px;
  margin: 0 5px;
  vertical-align: middle;
`;

export const AirlineLogo = styled(AirlineImg)`
  max-width: 18px;
  max-height: 18px;
  align-self: flex-start;
`;

export const FlightLineBottomTextStrong = styled.span`
  color: ${ColorPalette.HEX.DimGray2};
  font-size: 12px;
  font-weight: bold;

  & > span {
    text-transform: capitalize;
  }
`;

export const PrivateFareMessage = styled.div`
  font-size: 11px;
  line-height: 1.33;
  text-align: right;
  color: ${({ theme }) => theme.primaryBackgroundColor};
  display: ruby;
  font-weight: 600;
`;

export const PrivateFareMessageText = styled.div`
  vertical-align: top;
  padding-top: 3px;
`;

export const PrivateFareIconContainer = styled.div`
  height: 20px;
  width: 20px;
  margin-right: 5px;
`;

export const ContainerItemContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 40%;
  margin-left: auto;
`;

export const TravelerItemContainer = styled.div`
  /*width: 68%;*/
`;
export const PayAtDestination = styled.div`
  height: 20%;
  display: flex;
  align-items: center;
  margin-top: 4px;
`;

export const PayAtDestinationText = styled.div`
  font-size: 10px;
  font-weight: 400;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.67;
  letter-spacing: normal;
  width: 200px;
  color: ${({ theme }) => theme.dataCardHotels.cleanColor};
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`;

export const CheckCircleIcon = styled(FaRegCheckCircle)`
  font-size: 12px;
  color: ${({ theme }) => theme.dataCardHotels.cleanColor} !important;
  margin-top: 4px;
  margin-right: 4px;
  @media (min-width: 446px) {
    align-self: center;
    margin-top: 0;
  }
`;